import { Dispatch } from "@reduxjs/toolkit";
import { setAuthData, setLoading, setAuthError, setIdConnection, setUserData, setUserDataToUpdate, confirmUserDataUpdated, setUserRightHolders, setUserTraining, setColleges, setUserHealthPlan, setVacationsResume, logout } from "./authSlice";
import { loginRequest } from "../../../api/authApi";
import { AuthResponse, UserDataToUpdate } from "../../../interfaces/auth.interface";
import { AxiosError, AxiosResponse } from "axios";

import $ from 'jquery';
import { APPROVAL_EMPLOYEES, APPROVAL_GROUPS_COMPANIES, APPROVAL_RESPONSABLES, APPROVE_COUPON, CANCEL_APPROVED_COUPON, COMPANY_EMPLOYEES, CONTRACT_DOCUMENT_SIGNATURE_REQUEST, COUPON_RANGE_VALIDATION, COUPON_REQUEST_RESPONSIBLE_EMAILS, DOCUMENT_SIGNATURE_REQUEST, EMPLOYEES_BIRTHDAYS, EMPLOYEE_CONTRACTS_ONE, EMPLOYEE_CONTRACTS_THREE, EMPLOYEE_CONTRACTS_TWO, EMPLOYEE_PAYMENT_SLIPS_ONE, EMPLOYEE_PAYMENT_SLIPS_THREE, EMPLOYEE_PAYMENT_SLIPS_TWO, EMPLOYEE_RECORDS_ONE, EMPLOYEE_RECORDS_TWO, EMPLOYEE_RECORDS_THREE, EMPLOYEE_VACATIONS, GET_COLLEGES, GET_CONTACTS, GET_EMPLOYEE_INFORMATION, GET_EMPLOYEE_RIGHT_HOLDERS, GET_EMPLOYEE_TRAINING, GET_HEALTH_PLAN, GET_VACATIONS_RESUME, PAYMENT_SLIP_DOCUMENT_SIGNATURE_REQUEST, RECORD_DOCUMENT_SIGNATURE_REQUEST, UPDATE_USER_DATA, PENDING_COUPONS_EMPLOYEES_ONE, PENDING_COUPONS_EMPLOYEES_TWO, PENDING_COUPONS_EMPLOYEES_HISTORY_ONE, PENDING_COUPONS_EMPLOYEES_HISTORY_TWO, COUPONS_TO_MY_CHARGE_HISTORY_ONE, COUPONS_TO_MY_CHARGE_HISTORY_TWO, COUPONS_TO_MY_CHARGE_HISTORY_THREE, PENDING_COUPONS_EMPLOYEES_HISTORY_THREE, PENDING_COUPONS_EMPLOYEES_THREE, IN_MY_CHARGE_EMPLOYEES_CONTRACTS_ONE, IN_MY_CHARGE_EMPLOYEES_CONTRACTS_TWO, IN_MY_CHARGE_EMPLOYEES_CONTRACTS_THREE, IN_MY_CHARGE_EMPLOYEES_PAYMENT_SLIPS_ONE, IN_MY_CHARGE_EMPLOYEES_PAYMENT_SLIPS_TWO, IN_MY_CHARGE_EMPLOYEES_PAYMENT_SLIPS_THREE, IN_MY_CHARGE_EMPLOYEES_DOCUMENTS_ONE, IN_MY_CHARGE_EMPLOYEES_DOCUMENTS_TWO, IN_MY_CHARGE_EMPLOYEES_DOCUMENTS_THREE, EMPLOYEES_BIRTHDAYS_CURRENT, GET_STAFF_POSITIONS, EMPLOYEE_LOANS_ONE, EMPLOYEE_LOANS_TWO, EMPLOYEE_LOANS_THREE, EMPLOYEE_LOANS_TYPES, EMPLOYEE_LOANS_CURRENCIES, EMPLOYEE_LOAN_DETAILS, EMPLOYEE_LOAN_PERIOD, EMPLOYEE_LOAN_REQUEST, EMPLOYEES_VACATIONS_RESUME, EMPLOYEES_ANNIVERSARY, LOANS_TO_MY_CHARGE_HISTORY_ONE, LOANS_TO_MY_CHARGE_HISTORY_TWO, LOANS_TO_MY_CHARGE_HISTORY_THREE, LOANS_TO_MY_CHARGE_UPDATE_STATUS_ONE, LOANS_TO_MY_CHARGE_UPDATE_STATUS_TWO, LOANS_TO_MY_CHARGE_UPDATE_STATUS_THREE, EMPLOYEE_LOAN_CANCEL_RESULT, USER_ASSIGNED_COMPANIES, GET_YEAR_HOLIDAYS, BANK_ACCOUNTS_CONFIG, BANK_ACCOUNTS_LIST, BANKS_LIST, CURRENCIES_LIST_GENERIC, BANK_ACCOUNT_ADD, BANK_ACCOUNT_UPDATE, BANK_ACCOUNT_DELETE } from "../../../constants/signalRequestConsts";
import { setAnniversaryData, setBirthdaysData } from "../posts";
import { setCancelApprovedCouponResult, setContracts, setContractsSignedDatetime, setLoanDetails, setLoanPeriods, setLoanRequestResult, setLoancancelResult, setLoans, setLoansCurrencies, setLoansTypes, setPaymentSlipSignedDatetime, setPaymentSlips, setRecordSignedDatetime, setRecords, setVacations } from "../documents";
import { setApprovalEmployees, setApprovalGroupsCompanies, setApprovalResponsables, setAssignedCompanies, setCalendarEvents, setCompanyEmployees, setContacts, setCouponsResponsiblesData, setCouponsToApproveERPReponse, setCouponsToMyChargeEmployees, setCouponsToMyChargeEmployeesHistory, setCouponsTypesRangeSelectedIsValid, setEmployeesVacationsResume, setInMyChargeDocuments, setInMyChargeEmployeesContracts, setInMyChargeEmployeesPaymentSlips, setLoansToMyChargeEmployees, setLoanUpdateStatusResult, setStaffPositionsData } from "../userRequests";
import { updateUserDataRequest } from "../../../api/signalApi";
import { YearHolidays } from "../../../interfaces/employeeDocuments.interface";
import { getDatestring } from "../../../utils/date";
import { setBankAccounts, setBankConfig, setBanksList, setCurrenciesList, setOperationResult } from "../bank/bankSlice";


interface JqueryInterface extends JQueryStatic {
    hubConnection?: any
}
declare global {
    interface Window {
        jQuery: JqueryInterface;
    }
}

const jsquery: JqueryInterface = $;

window.jQuery = jsquery;
require('signalr');

export interface LoginData {
    UserName: string;
    Password: string;
}

export const loginUser = (loginData: LoginData) => {
    return async (dispatch: Dispatch) => {
        dispatch(setLoading(true));
        dispatch(setAuthError(""));
        const response: AuthResponse = await loginRequest(loginData)
            .then((resp: AxiosResponse<AuthResponse>) => {
                if (resp?.status !== 200 || resp.data?.Type !== 0 || !resp.data?.Value?.Companies?.length) {
                    return {
                        Type: 1,
                        Message: resp?.status !== 200
                            ? "Error, reintenta nuevamente en unos minutos o comunicate con el administrador."
                            : resp.data.Type === 1
                                ? resp.data.Message
                                : "Error, la informacion de tu usuario no es válida, por favor contacta al administrador.",
                        Value: null as any,
                    }
                }
                return {
                    Type: 0,
                    Message: "",
                    Value: resp.data.Value,
                }
            })
            .catch((e: AxiosError) => {
                if (e.code !== "ERR_NETWORK") {
                    console.log(e);
                }
                return {
                    Type: 1,
                    Message: e.code === "ERR_NETWORK"
                        ? "Error de conexión, por favor revisa tu conexión de internet."
                        : "Error desconocido.",
                    Value: null as any,
                }
            });
        if (response.Type === 1) {
            dispatch(setAuthError(response.Message));
        } else {
            dispatch(setAuthData(response.Value));
        }
        dispatch(setLoading(false));
    }

}

export const refreshToken = (token: string) => {
    return async (dispatch: Dispatch) => {
        var options = {
            qs: {
                AuthType: process.env.REACT_APP_AUTH_TYPE,
                Token: token,
                ModuleId: process.env.REACT_APP_MODULE_ID,
            }
        };
        const connection = jsquery.hubConnection(process.env.REACT_APP_SIGNALR_URL, options);
        const hubProxy = connection.createHubProxy(process.env.REACT_APP_SIGNALR_PROXY);

        hubProxy.on(process.env.REACT_APP_SIGNALR_RECEIVE, function (response: any) {
            const data = JSON.parse(response);
            switch (data.Name) {
                case EMPLOYEES_BIRTHDAYS:
                case EMPLOYEES_BIRTHDAYS_CURRENT:
                    dispatch(setBirthdaysData({
                        part: data.Part,
                        data: JSON.parse(data.Data),
                        count: data.Count,
                        isCurrent: data.Name === EMPLOYEES_BIRTHDAYS_CURRENT
                    }))
                    break;
                case EMPLOYEES_ANNIVERSARY:
                    dispatch(setAnniversaryData({
                        part: data.Part,
                        data: JSON.parse(data.Data),
                        count: data.Count,
                    }))
                    break;

                case EMPLOYEE_PAYMENT_SLIPS_ONE:
                case EMPLOYEE_PAYMENT_SLIPS_TWO:
                case EMPLOYEE_PAYMENT_SLIPS_THREE:
                    dispatch(setPaymentSlips({
                        Part: data.Part,
                        Data: JSON.parse(data.Data),
                        Count: data.Count,
                        requestId: data.Name,
                    }))
                    break;
                case EMPLOYEE_VACATIONS:
                    dispatch(setVacations({
                        Part: data.Part,
                        Data: JSON.parse(data.Data),
                        Count: data.Count
                    }))
                    break;
                case EMPLOYEE_RECORDS_ONE:
                case EMPLOYEE_RECORDS_TWO:
                case EMPLOYEE_RECORDS_THREE:
                    dispatch(setRecords({
                        Part: data.Part,
                        Data: JSON.parse(data.Data),
                        Count: data.Count,
                        requestId: data.Name,
                    }))
                    break;
                case DOCUMENT_SIGNATURE_REQUEST:
                    console.log(DOCUMENT_SIGNATURE_REQUEST)
                    console.log(data)
                    break;
                case PAYMENT_SLIP_DOCUMENT_SIGNATURE_REQUEST:
                    dispatch(setPaymentSlipSignedDatetime({
                        id: JSON.parse(data.Data)[0].NroBoletaNomina,
                        timestamp: JSON.parse(data.Data)[0].FirmadoFecha,
                    }))
                    break;
                case RECORD_DOCUMENT_SIGNATURE_REQUEST:
                    dispatch(setRecordSignedDatetime({
                        id: JSON.parse(data.Data)[0].NroBoletaNomina,
                        timestamp: JSON.parse(data.Data)[0].FirmadoFecha,
                    }))
                    break;
                case EMPLOYEE_CONTRACTS_ONE:
                case EMPLOYEE_CONTRACTS_TWO:
                case EMPLOYEE_CONTRACTS_THREE:
                    dispatch(setContracts({
                        Part: data.Part,
                        Data: JSON.parse(data.Data),
                        Count: data.Count,
                        requestId: data.Name,
                    }))
                    break;
                case EMPLOYEE_LOANS_ONE:
                case EMPLOYEE_LOANS_TWO:
                case EMPLOYEE_LOANS_THREE:
                    dispatch(setLoans({
                        Part: data.Part,
                        Data: JSON.parse(data.Data),
                        Count: data.Count,
                        requestId: data.Name,
                        outputValue: data.OutputValue,
                    }))
                    break;
                case EMPLOYEE_LOANS_TYPES:
                    dispatch(setLoansTypes(JSON.parse(data.Data)))
                    break;

                case EMPLOYEE_LOANS_CURRENCIES:
                    dispatch(setLoansCurrencies(JSON.parse(data.Data)))
                    break;

                case EMPLOYEE_LOAN_PERIOD:
                    dispatch(setLoanPeriods(JSON.parse(data.Data)))
                    break;
                case EMPLOYEE_LOAN_REQUEST:
                    const loanResult = JSON.parse(data.Data)
                    dispatch(setLoanRequestResult({
                        success: loanResult.length ? loanResult[0].Success : 0,
                        msg: loanResult.length && loanResult[0].Success === 1
                            ? 'Prestamo solicitado con exito.'
                            : loanResult.length
                                ? loanResult[0].Response
                                : "Error solicitando el prestamo.",
                        id: loanResult.length ? loanResult[0].Output1 : null,
                    }));
                    break;
                case EMPLOYEE_LOAN_DETAILS:
                    dispatch(setLoanDetails(JSON.parse(data.Data)))
                    break;

                case CONTRACT_DOCUMENT_SIGNATURE_REQUEST:
                    dispatch(setContractsSignedDatetime({
                        id: JSON.parse(data.Data)[0]?.NroIdentificadorContrato,
                        timestamp: JSON.parse(data.Data)[0]?.FirmadoFecha,
                    }))
                    break
                // case CONTRACT_OBSERVATION:
                //     console.log(data)
                //     dispatch(setContractObservation(JSON.parse(data.Data)))
                //     break
                case COUPON_RANGE_VALIDATION:
                    let finalData = JSON.parse(data.Data);
                    dispatch(setCouponsTypesRangeSelectedIsValid({
                        success: finalData.length ? finalData[0].Success : 0,
                        response: finalData.length ? finalData[0].Response : "Error validando el rango de fechas."
                    }))
                    break
                case COUPON_REQUEST_RESPONSIBLE_EMAILS:
                    dispatch(setCouponsResponsiblesData(JSON.parse(data.Data) as any))
                    break
                case GET_EMPLOYEE_INFORMATION:
                    dispatch(setUserData(JSON.parse(data.Data)[0]));
                    break
                case UPDATE_USER_DATA:
                    dispatch(confirmUserDataUpdated());
                    break
                case GET_EMPLOYEE_RIGHT_HOLDERS:
                    dispatch(setUserRightHolders(JSON.parse(data.Data)));
                    break
                case GET_EMPLOYEE_TRAINING:
                    console.log(JSON.parse(data.Data))
                    dispatch(setUserTraining({
                        data: JSON.parse(data.Data),
                        count: data.Count,
                        part: data.Part,
                    }));
                    break
                case GET_COLLEGES:
                    dispatch(setColleges({
                        data: JSON.parse(data.Data),
                        count: data.Count,
                        part: data.Part,
                    }));
                    break
                case GET_CONTACTS:
                    dispatch(setContacts({
                        data: JSON.parse(data.Data),
                        count: data.Count,
                        part: data.Part,
                        outputValue: data.OutputValue,
                    }));
                    break

                case GET_HEALTH_PLAN:
                    dispatch(setUserHealthPlan({
                        data: JSON.parse(data.Data),
                        count: data.Count,
                        part: data.Part,
                    }));
                    break

                case GET_VACATIONS_RESUME:
                    dispatch(setVacationsResume({
                        data: JSON.parse(data.Data),
                        count: data.Count,
                        part: data.Part,
                    }));
                    break

                case APPROVAL_GROUPS_COMPANIES:
                    dispatch(setApprovalGroupsCompanies({
                        data: JSON.parse(data.Data),
                        count: data.Count,
                        part: data.Part,
                    }));
                    break

                case USER_ASSIGNED_COMPANIES:
                    dispatch(setAssignedCompanies({
                        data: JSON.parse(data.Data),
                        count: data.Count,
                        part: data.Part,
                    }));
                    break

                case APPROVAL_RESPONSABLES:
                    dispatch(setApprovalResponsables({
                        data: JSON.parse(data.Data),
                        count: data.Count,
                        part: data.Part,
                    }));
                    break

                case COMPANY_EMPLOYEES:
                    dispatch(setCompanyEmployees({
                        data: JSON.parse(data.Data),
                        count: data.Count,
                        part: data.Part,
                        outputValue: data.OutputValue,
                    }));
                    break

                case EMPLOYEES_VACATIONS_RESUME:
                    console.log(data.Name, JSON.parse(data.Data));
                    console.log(data.Name, data);
                    dispatch(setEmployeesVacationsResume({
                        data: JSON.parse(data.Data),
                        count: data.Count,
                        part: data.Part,
                        outputValue: data.OutputValue,
                    }));
                    break

                case APPROVAL_EMPLOYEES:
                    dispatch(setApprovalEmployees({
                        data: JSON.parse(data.Data),
                        count: data.Count,
                        part: data.Part,
                    }));
                    break

                case PENDING_COUPONS_EMPLOYEES_ONE:
                case PENDING_COUPONS_EMPLOYEES_TWO:
                case PENDING_COUPONS_EMPLOYEES_THREE:
                    dispatch(setCouponsToMyChargeEmployees({
                        data: {
                            data: JSON.parse(data.Data),
                            count: data.Count,
                            part: data.Part,
                        },
                        requestId: data.Name === PENDING_COUPONS_EMPLOYEES_ONE
                            ? COUPONS_TO_MY_CHARGE_HISTORY_ONE
                            : data.Name === PENDING_COUPONS_EMPLOYEES_TWO
                                ? COUPONS_TO_MY_CHARGE_HISTORY_TWO
                                : COUPONS_TO_MY_CHARGE_HISTORY_THREE
                    }));
                    break

                case LOANS_TO_MY_CHARGE_HISTORY_ONE:
                case LOANS_TO_MY_CHARGE_HISTORY_TWO:
                case LOANS_TO_MY_CHARGE_HISTORY_THREE:
                    console.log(JSON.parse(data.Data))
                    dispatch(setLoansToMyChargeEmployees({
                        data: {
                            data: JSON.parse(data.Data),
                            count: data.Count,
                            part: data.Part,
                            outputValue: data.OutputValue,
                        },
                        requestId: data.Name
                    }));
                    break

                case LOANS_TO_MY_CHARGE_UPDATE_STATUS_ONE:
                case LOANS_TO_MY_CHARGE_UPDATE_STATUS_TWO:
                case LOANS_TO_MY_CHARGE_UPDATE_STATUS_THREE:
                    dispatch(setLoanUpdateStatusResult({
                        data: {
                            msg: data.Message,
                            success: data.IsSuccess,
                        },
                        requestId: data.Name
                    }));
                    break

                case EMPLOYEE_LOAN_CANCEL_RESULT:
                    dispatch(setLoancancelResult({
                        msg: JSON.parse(data.Data)?.length ? JSON.parse(data.Data)[0].Response : '',
                        success: JSON.parse(data.Data)?.length ? JSON.parse(data.Data)[0].Success : false,
                    }));
                    break
                // "[{\"Success\":1,\"Response\":\"\",\"Output1\":\"9959f184-a89f-4c1c-b8a2-665182e2b7e4\",\"Output2\":null}]"
                case PENDING_COUPONS_EMPLOYEES_HISTORY_ONE:
                case PENDING_COUPONS_EMPLOYEES_HISTORY_TWO:
                case PENDING_COUPONS_EMPLOYEES_HISTORY_THREE:
                    dispatch(setCouponsToMyChargeEmployeesHistory({
                        data: {
                            data: JSON.parse(data.Data),
                            count: data.Count,
                            part: data.Part,
                        },
                        requestId: data.Name === PENDING_COUPONS_EMPLOYEES_HISTORY_ONE
                            ? COUPONS_TO_MY_CHARGE_HISTORY_ONE
                            : data.Name === PENDING_COUPONS_EMPLOYEES_HISTORY_TWO
                                ? COUPONS_TO_MY_CHARGE_HISTORY_TWO
                                : COUPONS_TO_MY_CHARGE_HISTORY_THREE
                    }));
                    break
                case APPROVE_COUPON:
                    dispatch(setCouponsToApproveERPReponse({ data: JSON.parse(data.Data)[0] } as any))
                    break
                case CANCEL_APPROVED_COUPON:
                    console.log(JSON.parse(data.Data))
                    dispatch(setCancelApprovedCouponResult(JSON.parse(data.Data)[0]))
                    break
                case IN_MY_CHARGE_EMPLOYEES_CONTRACTS_ONE:
                case IN_MY_CHARGE_EMPLOYEES_CONTRACTS_TWO:
                case IN_MY_CHARGE_EMPLOYEES_CONTRACTS_THREE:
                    dispatch(setInMyChargeEmployeesContracts({
                        data: {
                            data: JSON.parse(data.Data),
                            count: data.Count,
                            part: data.Part,
                            outputValue: data.OutputValue,
                        },
                        requestId: data.Name,
                    }));
                    break
                case IN_MY_CHARGE_EMPLOYEES_PAYMENT_SLIPS_ONE:
                case IN_MY_CHARGE_EMPLOYEES_PAYMENT_SLIPS_TWO:
                case IN_MY_CHARGE_EMPLOYEES_PAYMENT_SLIPS_THREE:
                    dispatch(setInMyChargeEmployeesPaymentSlips({
                        data: {
                            data: JSON.parse(data.Data),
                            count: data.Count,
                            part: data.Part,
                            outputValue: data.OutputValue,
                        },
                        requestId: data.Name,
                    }));
                    break
                case IN_MY_CHARGE_EMPLOYEES_DOCUMENTS_ONE:
                case IN_MY_CHARGE_EMPLOYEES_DOCUMENTS_TWO:
                case IN_MY_CHARGE_EMPLOYEES_DOCUMENTS_THREE:
                    console.log(data);
                    dispatch(setInMyChargeDocuments({
                        data: {
                            data: JSON.parse(data.Data),
                            count: data.Count,
                            part: data.Part,
                            outputValue: data.OutputValue,
                        },
                        requestId: data.Name,
                    }));
                    break
                case GET_STAFF_POSITIONS:
                    dispatch(setStaffPositionsData(JSON.parse(data.Data)));
                    break
                case GET_YEAR_HOLIDAYS:
                    const holidays = JSON.parse(data.Data)
                        .map((e: YearHolidays) => {
                            const date = new Date(e.Fecha);
                            const utcDate = new Date(
                                date.getFullYear(),
                                date.getMonth(),
                                date.getDate()
                            );
                            return {
                                ...e,
                                Id: e.IdConfiguracionFeriado,
                                customId: `holiday-${e.IdConfiguracionFeriado}`,
                                customDate: `${getDatestring(utcDate, '-', true)} 12:00:00`,
                                RangeDateInfo: `${getDatestring(utcDate, '/', false)} 12:00:00`,
                                Name: e.Descripcion,
                            };
                        }
                        );
                    dispatch(setCalendarEvents({ data: holidays }))
                    break
                case BANK_ACCOUNTS_CONFIG:
                    dispatch(setBankConfig(JSON.parse(data.Data)));
                    break;
                case BANK_ACCOUNTS_LIST:
                    dispatch(setBankAccounts(JSON.parse(data.Data)));
                    break;
                case BANKS_LIST:
                    dispatch(setBanksList(JSON.parse(data.Data)));
                    break;
                case CURRENCIES_LIST_GENERIC:
                    dispatch(setCurrenciesList(JSON.parse(data.Data)));
                    break;
                case BANK_ACCOUNT_ADD:
                case BANK_ACCOUNT_UPDATE:
                case BANK_ACCOUNT_DELETE:
                    let operationResult = { success: false, msg: "Error desconocido" };
                    try {
                        const parsedData = JSON.parse(data.Data);
                        const resultObj = Array.isArray(parsedData) && parsedData.length > 0 ? parsedData[0] : parsedData;
                        if (resultObj) {
                            const isSuccess = resultObj.IsSuccess === true || resultObj.Success === 1 || resultObj.Success === true;
                            const msg = resultObj.Message || resultObj.Response || resultObj.Msg || (isSuccess ? "Operación exitosa" : "Error en la operación");
                            operationResult = { success: isSuccess, msg };
                        }
                    } catch (e) {
                        console.error("Error parsing bank operation response", e);
                    }

                    dispatch(setOperationResult(operationResult));
                    break;
                default:
                    console.log(data);
            }
        });
        // connect
        connection
            .start()
            .done(function () {
                console.log("Now connected, connection ID=" + connection.id);
                dispatch(setIdConnection(connection.id));
            })
            .fail(function () {
                console.log("Could not connect");
                dispatch(logout());
                // alert("Conexion fallida, posiblemente token vencido");
                // dispatch({
                // 	type: 'REFRESH_IDCONNECTION',
                // 	payload: false
                // });
            });
    }
}

export const updateUserData = (newData: UserDataToUpdate) => {
    return async (dispatch: Dispatch) => {
        dispatch(setUserDataToUpdate(newData));
        await updateUserDataRequest(newData);
    }
} 
